<template>
  <div class="top-img">
    <img :src="img" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: require("../assets/awards/img" +
        this.$route.params.imgId +
        "-map.png"),
    };
    
  },
 
};
</script>

<style lang="less" scoped>
.top-img {
  img {
    // height: 260px;
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/top.vue